export default __webpack_public_path__ + "static/media/gallery4.d321dffe.jpeg";